/* global app */
import React, { useMemo } from 'react'
import { connect } from 'react-redux'
import { SBIntegrations } from 'sb-integrations-nairabet'

const { BetOnActionGame, useSession } = SBIntegrations

const BetOnAction = ({ isLogged: isAuth, anonymousMode, openLoginModal }) => {
  const session = useSession()

  const locale = useMemo(() => `lang_${app.config.lang}_${app.config.mainCountryCode}_1_1`.toLocaleLowerCase())

  return (
    <BetOnActionGame
      session={session}
      locale={locale}
      isAuth={isAuth}
      anonymousMode={anonymousMode}
      openLoginModal={openLoginModal}
      lang={app.config.lang}
      currency={app.config.currency}
      style={{ 'min-height': '75vh' }}
    />
  )
}

const mapStateToProps = ({ Auth: { isLogged } }) => ({ isLogged })

const mapDispatchToProps = dispatch => ({
  openLoginModal: () => dispatch({ type: 'TOGGLE_BY_KEY', payload: { key: 'TOGGLE_OPEN_LOGIN_MODAL', isOpen: true } })
})

export default connect(mapStateToProps, mapDispatchToProps)(BetOnAction)
